import axios from 'axios'

export type Window = '24h' | '7d' | '30d'

export interface ProjectStat {
  project: string
  requests: number
  avgDuration: number
  errors: number
  errorRate: number
}

export interface CarrierStat {
  name: string
  requests: number
  success: number
  noPrice: number
  failed: number
  successRate: number
}

export interface ErrorReason {
  reason: string
  count: number
}

export interface RouteStat {
  route: string
  project: string
  requests: number
  empty: number
  emptyRate: number
}

export interface HourBucket {
  hour: string
  requests: number
}

export interface StatsData {
  total: number
  avgDuration: number
  byProject: ProjectStat[]
  byCarrier: CarrierStat[]
  byError: ErrorReason[]
  byRoute: RouteStat[]
  hourly: HourBucket[]
}

const StatsService = {
  getStats(window: Window = '24h'): Promise<StatsData> {
    return axios.get(`/admin/stats?window=${window}`).then(r => r.data)
  },
  reset(): Promise<void> {
    return axios.delete('/admin/stats').then(() => undefined)
  },
}

export default StatsService
